import { render, staticRenderFns } from "./ImageSwiper.vue?vue&type=template&id=4e8a2a72&scoped=true"
import script from "./ImageSwiper.vue?vue&type=script&lang=js"
export * from "./ImageSwiper.vue?vue&type=script&lang=js"
import style0 from "./ImageSwiper.vue?vue&type=style&index=0&id=4e8a2a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a2a72",
  null
  
)

export default component.exports